import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42.52 42.52",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M29.78 5.86h-2v2.42H14.57V5.86h-2v2.42H6.09v27.48H36.1V8.28h-6.32V5.86ZM8.09 33.76V16.43H34.1v17.33H8.09ZM34.1 10.28v4.15H8.09v-4.15h4.48v2.42h2v-2.42h13.21v2.42h2v-2.42h4.32Z" }, null, -1),
    _createElementVNode("path", { d: "M18.03 19.11h-3.46v2h1.46v6.88h-1.46v2h4.62v-2h-1.16v-8.88zM21.25 29.99h7.38V19.11h-7.38v10.88Zm2-8.88h3.38v6.88h-3.38v-6.88Z" }, null, -1)
  ])))
}
export default { render: render }